<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.633 2.155a1.14 1.14 0 0 0-1.616 0l-8.482 8.493-3.563-3.575A1.163 1.163 0 1 0 .355 8.747l4.372 4.372a1.137 1.137 0 0 0 1.617 0l9.29-9.29a1.14 1.14 0 0 0 0-1.674Z"
      fill="currentColor"
    />
  </svg>
</template>
